module.exports = __webpack_public_path__ + "static/media/slider_3_collab_user_es.184bab19.svg";